require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-nicola-navone-un-regard-sur-larchitecture-recente-au-tessin-monte-carasso-21-giugno-2021.json") })
        }
      }, "path---relazioni-e-conferenze-nicola-navone-un-regard-sur-larchitecture-recente-au-tessin-monte-carasso-21-giugno-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-nicola-navone-un-regard-sur-larchitecture-recente-au-tessin-monte-carasso-21-giugno-2021!./.cache/json/relazioni-e-conferenze-nicola-navone-un-regard-sur-larchitecture-recente-au-tessin-monte-carasso-21-giugno-2021.json
// module id = 737
// module chunks = 231608221292675